import { ContactConfig, contactResources } from "../Resources/Contact";
import { getLang } from "../lib";
import FadeInOnScroll from "./FadeInOnScroll";
import { useState } from "react";

function Contact() {
    const lang = getLang();
    const resources = contactResources[lang];
    document.title = resources.Title;

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        interest: "BPO",
        message: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSendEmail = (e) => {
        e.preventDefault();
        const { name, email, phone, interest, message } = formData;

        const body = `
${resources.FullNameLabel}:\t\t ${name}
${resources.EmailLabel}:\t\t\t ${email}
${resources.PhoneLabel}:\t\t\t ${phone}
${resources.InterestLabel}:\t ${interest}\n
${resources.MessageLabel}:\n
${message}`;

        window.location.href = `mailto:${ContactConfig.email}?subject=${encodeURIComponent(
            resources.EmailSubject
        )}&body=${encodeURIComponent(body)}`;

        setFormData({
            name: "",
            email: "",
            phone: "",
            interest: "BPO",
            message: "",
        });
    };

    const handleCardClick = (url) => window.open(url, "_blank", "noopener,noreferrer");

    // Reusable contact cards array
    const contactCards = [
        {
            icon: "📍",
            label: resources.Address,
            onClick: () => handleCardClick(ContactConfig.addressLink),
        },
        {
            icon: "📧",
            label: ContactConfig.email,
            onClick: () => (window.location.href = `mailto:${ContactConfig.email}`),
        },
        {
            icon: "📞",
            label: ContactConfig.phone,
            onClick: () => (window.location.href = `tel:${ContactConfig.phone}`),
        },
        {
            icon: (
                <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                </svg>
            ),
            label: resources.linkedin,
            onClick: () => handleCardClick(ContactConfig.linkedin),
        },
        {
            icon: (
                <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z" />
                </svg>
            ),
            label: resources.facebook,
            onClick: () => handleCardClick(ContactConfig.facebook),
        },
    ];

    return (
        <div className="contact-page page">
            <section className="mx-50">
                <FadeInOnScroll delay={0.2}>
                    <h1>{resources.Title}</h1>
                    <p>{resources.Description}</p>
                </FadeInOnScroll>
            </section>

            <div className="page-item contact-form-wrapper">
                {/* Form Fields in old layout */}
                <FadeInOnScroll delay={0.5}>
                    <div className="txt-holder child-item">
                        <form className="contact-form attractive-form" onSubmit={handleSendEmail}>

                            <div className="lbl">
                                <label htmlFor="name">{resources.FullNameLabel}</label>
                            </div>
                            <input
                                type="text"
                                id="name"
                                name="name"
                                placeholder={resources.FullNamePlaceholder}
                                required
                                value={formData.name}
                                onChange={handleChange}
                            />

                            <div className="lbl">
                                <label htmlFor="email">{resources.EmailLabel}</label>
                            </div>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                placeholder={resources.EmailPlaceholder}
                                required
                                value={formData.email}
                                onChange={handleChange}
                            />

                            <div className="lbl">
                                <label htmlFor="phone">{resources.PhoneLabel}</label>
                            </div>
                            <input
                                type="tel"
                                id="phone"
                                name="phone"
                                placeholder={resources.PhonePlaceholder}
                                required
                                value={formData.phone}
                                onChange={handleChange}
                            />

                            <div className="lbl">
                                <label htmlFor="interest">{resources.InterestLabel}</label>
                            </div>
                            <select
                                id="interest"
                                name="interest"
                                required
                                value={formData.interest}
                                onChange={handleChange}
                            >
                                <option value="BPO">BPO</option>
                                <option value="FPA">FP&A</option>
                                <option value="CFO">CFO</option>
                                <option value="Other">{resources.OtherOption}</option>
                            </select>

                            <div className="lbl">
                                <label htmlFor="message">{resources.MessageLabel}</label>
                            </div>
                            <textarea
                                id="message"
                                name="message"
                                placeholder={resources.MessagePlaceholder}
                                required
                                value={formData.message}
                                onChange={handleChange}
                            ></textarea>

                            <button type="submit" className="primaryCTA-btn schedule-btn">
                                {resources.SubmitButton}
                            </button>
                        </form>
                    </div>
                </FadeInOnScroll>

                {/* Contact Cards */}
                <div className="contact-info-cards">
                    {contactCards.map((card, idx) => (
                        <FadeInOnScroll key={idx} delay={0.2 + idx * 0.1}>
                            <div className="contact-card clickable" onClick={card.onClick}>
                                <div className="icon">{card.icon}</div>
                                <span>{card.label}</span>
                                <span className="arrow">→</span>
                            </div>
                        </FadeInOnScroll>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default Contact;
